module.exports = __webpack_public_path__ + "static/img/2-4.a73439a7.png";